<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      `app-header--${finalHeaderTheme}`,
      {'app-header--scrolled': isScrolled || isFixedHeaderPage}
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <div class="app-header__logo" @click="goToHome">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
      <div class="app-header__logo-text">
        {{domainConfig?.['siteName']}}
      </div>
    </div>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/')}" @click="goToHome">
        Home
      </div>
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/all')}"
        @mouseover="showCategoriesDropdown = true" @mouseleave="showCategoriesDropdown = false">
        Categories

        <svg class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': showCategoriesDropdown}"
          xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
          <path
            d="M4.00051 2.79018L0.974418 0.146758C0.750414 -0.0489193 0.392007 -0.0489193 0.168003 0.146758C-0.056001 0.342435 -0.056001 0.655519 0.168003 0.851196L3.51585 3.77568C3.53621 3.80414 3.56065 3.82905 3.58916 3.85395C3.70319 3.95357 3.84982 4.00338 4.00051 3.99982C4.14713 3.99982 4.29782 3.95357 4.41186 3.85395C4.44037 3.82905 4.46481 3.80414 4.48517 3.77568L7.83302 0.851196C7.94298 0.755136 8 0.627057 8 0.498977C8 0.370897 7.94298 0.242818 7.83302 0.146758C7.60901 -0.0489193 7.25061 -0.0489193 7.0266 0.146758L4.00051 2.79018Z"
            fill="white" />
        </svg>

        <!-- Categories下拉菜单 -->
        <div class="app-header__dropdown" v-if="showCategoriesDropdown">
          <div class="app-header__dropdown-content">
            <div class="app-header__dropdown-items">
              <div class="app-header__dropdown-item" v-for="category in categories"
                :key="category.value" @click.stop="goToCategory(category.value)">
                <div class="app-header__dropdown-item-icon-container">
                  <img :src="category.originalIcon" alt="" class="app-header__dropdown-item-icon">
                </div>
                <div class="app-header__dropdown-item-text">{{ category.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/rank')}"
        @click="$router.push('/rank')">
        Rankings
      </div>
      <!-- <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/resources')}"
        @click="$router.push('/resources')">
        Resources
      </div> -->
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
      @click="toggleMobileMenu">
      <img v-if="!showMobileMenu" :src="menuSrc" class="mean" alt="">
      <img v-else src="@/assets/clos-menu.svg" class="clos" alt="">
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMobileMenu) -->
    <div class="app-header__mobile-menu" v-if="showMobileMenu && (deviceType === 'mobile')">
      <div class="app-header__mobile-menu-header">
        <div class="app-header__logo" @click="goToHomeAndCloseMenu">
          <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
          <div class="app-header__logo-text">
            {{domainConfig?.['siteName']}}
          </div>
        </div>
        <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
          <img src="@/assets/clos-menu.svg" alt="Close menu">
        </div>
      </div>

      <div class="app-header__mobile-menu-content">
        <!-- Categories Section -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-section-title">Categories</div>
          <div class="app-header__mobile-menu-links">
            <div class="app-header__mobile-menu-link" v-for="category in categories"
              :key="category.value" @click="goToCategoryAndCloseMenu(category.value)">
              {{ category.name }}
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Rankings Section -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-section-title">Rankings</div>
          <div class="app-header__mobile-menu-links">
            <div class="app-header__mobile-menu-link" v-for="item in rankingsLinks" :key="item.name"
              @click="goToLinkAndCloseMenu(item.path)">
              {{ item.name }}
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Resources Section -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-section-title">Resources</div>
          <div class="app-header__mobile-menu-links">
            <div class="app-header__mobile-menu-link" v-for="item in resourcesLinks"
              :key="item.name" @click="goToLinkAndCloseMenu(item.path)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      categories: 'categories',
      categoriesLoaded: 'categoriesLoaded',
      headerTheme: 'headerTheme' // 从Vuex获取headerTheme
    }),
    isFixedHeaderPage () {
      return ['categories', 'categoriesChannel', 'detail', 'rankings', 'about-us', 'privacy-policy', 'terms-of-service', 'disclaimer'].includes(this.$route.name);
    },
    finalHeaderTheme () {
      return this.isFixedHeaderPage ? 'dark' : this.headerTheme;
    },
    menuSrc () {
      return require('@/assets/mobile-menu.svg')
    }
  },
  data () {
    return {
      showMobileMenu: false,
      showCategoriesDropdown: false,
      isScrolled: false,
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'Categories', link: '/all' },
        { name: 'Rankings', link: '/rank' },
        { name: 'Resources', link: '/resources' },
      ],
      rankingsLinks: [
        { name: 'Weekly Hot Books', path: '/rank?tab=weekly' },
        { name: 'Monthly Hot Books', path: '/rank?tab=monthly' },
        { name: 'Yearly Hot Books', path: '/rank?tab=yearly' },
      ],
      resourcesLinks: [
        { name: 'Terms of Services', path: '/terms-of-service' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Disclaimer', path: '/disclaimer' },
        { name: 'About Us', path: '/about-us' },
      ],
    };
  },
  methods: {
    handleScroll () {
      this.isScrolled = window.scrollY > 0;
    },
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    },

    toggleCategoriesDropdown () {
      this.showCategoriesDropdown = !this.showCategoriesDropdown;
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 处理首页特殊情况
      if (link === '/' && currentPath !== '/') {
        return false;
      }

      // Categories页面特殊处理
      if (link === '/categories') {
        // 如果路径是/categories或者是带有特定类别的路径（如/biography, /romance等）
        if (currentPath === '/categories') {
          return true;
        }

        // 检查是否是类别页面
        const categoryValues = this.categories.map(c => `/${c.value}`);
        if (categoryValues.includes(currentPath)) {
          return true;
        }

        return false;
      }

      // 其他页面直接比较路径
      return currentPath === link;
    },

    goToHome () {
      if (this.$route.path !== '/') {
        // 检查是否存在channel参数
        if (this.$route.params.channel) {
          // 如果有channel参数，使用完整路径
          window.location.href = `/${this.$route.params.channel}`;
        } else {
          // 保留查询参数
          this.$router.push({
            path: '/',
          });
        }
      }
    },

    // 获取导航链接
    getNavLink (link) {
      // 获取当前URL的查询参数
      const currentQuery = this.$route.query;
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果是首页链接
        if (link === '/') {
          return `/${this.$route.params.channel}/${queryString}`;
        }
        // 其他链接
        return `/${this.$route.params.channel}${link}${queryString}`;
      }
      return `${link}${queryString}`;
    },

    // 导航到特定类别页面
    goToCategory (category) {
      // 关闭下拉菜单
      this.showCategoriesDropdown = false;

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}/${category}`);
      } else {
        // 如果没有channel参数，直接导航到类别页面
        this.$router.push(`/${category}`);
      }
    },
    goToLinkAndCloseMenu (path) {
      this.$router.push(path);
      this.toggleMobileMenu();
    },
    goToCategoryAndCloseMenu (category) {
      this.goToCategory(category);
      this.toggleMobileMenu(); // goToCategory doesn't close menu
    },
    goToHomeAndCloseMenu () {
      this.goToHome();
      this.toggleMobileMenu();
    },
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body滚动
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    if (!this.isFixedHeaderPage) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }

      // 关闭分类下拉菜单
      this.showCategoriesDropdown = false;
    });

    // 点击其他区域关闭下拉菜单
    document.addEventListener('click', (event) => {
      const dropdown = document.querySelector('.app-header__nav-item--has-dropdown');
      if (dropdown && !dropdown.contains(event.target) && this.showCategoriesDropdown) {
        this.showCategoriesDropdown = false;
      }
    });

    if (!this.isFixedHeaderPage) {
      window.addEventListener('scroll', this.handleScroll);
    } else {
      this.isScrolled = true;
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	padding: rem(4) rem(180);
	height: rem(64);
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	transition: background-color 0.3s, box-shadow 0.3s;

	.app-header__logo-text,
	.app-header__nav-item {
		color: #fff;
	}

	.app-header__nav-item--active {
		border-bottom-color: #fff;
	}

	&--scrolled {
		background: linear-gradient(180deg, #161350 0%, #08011b 100%);
	}

	&--dark {
		background-color: transparent; // Dark theme background
	}

	&--reletive {
		position: relative;
	}

	&__logo {
		display: flex;
		align-items: center;
		gap: rem(16);
		cursor: pointer;

		&-icon {
			width: rem(32);
			height: rem(32);
		}

		&-text {
			font-size: rem(24);
			font-weight: 900;
			text-transform: uppercase;
		}
	}

	&__nav {
		display: flex;
		gap: rem(52);
		align-items: center;

		&-item {
			height: rem(52);
			padding: rem(8);
			display: flex;
			align-items: center;
			gap: rem(8);
			font-size: rem(14);
			font-weight: 400;
			cursor: pointer;
			border-bottom: 2px solid transparent;
			transition: border-color 0.3s;
			position: relative;

			&--active {
				font-weight: 900;
				border-bottom-color: #2c3337;
			}
		}
	}

	&__dropdown {
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		padding-top: rem(10);
		border-radius: 12px;
		background: linear-gradient(180deg, #161350 0%, #08011b 100%);
		box-shadow: 0px 4px 8px 0px rgba(22, 19, 80, 0.36);

		&-content {
			background: rgba(30, 26, 83, 0.9);
			border-radius: rem(8);
			padding: rem(20);
			box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.2);
		}

		&-items {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: rem(10) rem(20);
		}

		&-item {
			display: flex;
			align-items: center;
			gap: rem(10);
			padding: rem(8) rem(12);
			border-radius: rem(4);
			transition: background-color 0.2s;
			color: #fff;

			&:hover {
				background-color: rgba(255, 255, 255, 0.1);
			}

			&-icon-container {
				width: rem(24);
				height: rem(24);
				display: flex;
				align-items: center;
				justify-content: center;
			}

			&-icon {
				max-width: 100%;
				max-height: 100%;
			}

			&-text {
				font-size: rem(14);
			}
		}
	}
}

.detect_deviece_mobile {
	.app-header {
		padding: 0 rem(16);

		&__mobile-trigger {
			.mean {
				width: rem(24);
				height: rem(24);
			}
			.clos {
				width: rem(16);
				height: rem(16);
			}
		}

		&__mobile-menu {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background: linear-gradient(180deg, rgba(8, 1, 27, 1) 0%, rgba(22, 19, 80, 1) 100%);
			display: flex;
			flex-direction: column;
			z-index: 1001;
		}

		&__mobile-menu-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: rem(14) rem(16);
			height: rem(64);
			flex-shrink: 0;

			.app-header__logo-text {
				color: #fff;
			}
		}

		&__mobile-menu-content {
			padding: rem(24) rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			overflow-y: auto;
		}

		&__mobile-menu-section {
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&__mobile-menu-section-title {
			color: #ffffff;
			font-family: 'Roboto-Bold', sans-serif;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 700;
		}

		&__mobile-menu-links {
			display: flex;
			flex-wrap: wrap;
			gap: rem(6);
		}

		&__mobile-menu-link {
			background: rgba(255, 255, 255, 0.1);
			border-radius: rem(6);
			padding: rem(10) rem(16);
			flex-basis: calc(50% - rem(3));
			box-sizing: border-box;
			height: rem(40);
			flex: 0 0 calc((100% - rem(6)) / 2); /* 使每个子元素占1/3的宽度 */

			color: #ffffff;
			text-align: center;
			font-size: rem(12);
			line-height: rem(14); // Vertically align text
			font-weight: 400;
			cursor: pointer;

			display: flex;
			align-items: center;
			justify-content: center;
		}

		&__mobile-menu-divider {
			height: 1px;
			background: #ffffff;
			opacity: 0.1;
			width: 100%;
		}
	}
}
</style>
